import React, {useState, useEffect} from "react";
import {
    ControlLabel,
    FormControl,
    FormGroup,
    Button,
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import {
    getUser,
    getToken,
    setUserSession,
    retrieveFCMToken
} from "../utils/Common";
import {
    putUser,
    getUserMe
} from "../utils/bedrockAPI";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import "./AccountInfo.css";

export default function AccountInfo(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [company, setCompany] = useState("");
    const [pwmApp,setPwmApp] = useState(false);
    const [fixingUser, setFixingUser] = useState(false);

    useEffect(() => {
        if (window.matchMedia('(display-mode: standalone)').matches) {
            setPwmApp(true);
        }
        const user = getUser();
        if(user) {
            if(user.firstName!=null) setFirstName(user.firstName);
            if(user.lastName!=null) setLastName(user.lastName);
            if(user.email!=null) setEmail(user.email);
            if(user.company!=null) setCompany(user.company);
            if(user.phone!=null) setPhone(user.phone);
        }
        props.setShowError(false);
        if(!user.firstName||user.firstName==="") {
            props.setErrorStatus("success-message");
            props.setErrorMessage("Please update your name in our records");
            props.setShowError(true);
            setFixingUser(true);
        }

        retrieveFCMToken();
    },[])

    async function handleChangeAccountInfo(e) {
        e.preventDefault();
        if(window.confirm('Are you sure the information looks correct?')) {
            setIsLoading(true);
            let changes = {
                email: email,
                phone: phone,
                firstName: firstName,
                lastName: lastName,
                company: company,
            }

            await putUser(getUser().userId,changes);
            const newUser = await getUserMe();
            setUserSession(getToken(),newUser);
            setIsLoading(false);
            props.setShowError(false);
            if(fixingUser) {
                props.history.push("/dashboard");
            }
        }
    }

    return (
        <div className="account-info-page">
            <header className="account-info-header">
                <h1>Account Information</h1>
                <p className="account-info-subtitle">
                    Update your contact details. This information is used for account notifications and support.
                </p>
            </header>

            {fixingUser && (
                <div className="account-info-callout">
                    Please complete your profile before continuing to your cameras.
                </div>
            )}

            {getUser().role==="ADMIN" && (
                <div className="account-info-admin">
                    <CopyToClipboard text={getToken()}>
                        <Button className="btn-brand-outline btn-compact">Access Token</Button>
                    </CopyToClipboard>
                    <CopyToClipboard text={getUser().userId}>
                        <Button className="btn-brand-outline btn-compact">User ID</Button>
                    </CopyToClipboard>
                </div>
            )}

            <div className="account-info-panel">
                <form onSubmit={(e) => handleChangeAccountInfo(e)}>
                    <div className="account-info-form-grid">
                        <FormGroup controlId="firstName" className="account-info-field">
                            <ControlLabel>First Name</ControlLabel>
                            <FormControl
                                autoFocus={!pwmApp}
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup controlId="lastName" className="account-info-field">
                            <ControlLabel>Last Name</ControlLabel>
                            <FormControl
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup controlId="company" className="account-info-field">
                            <ControlLabel>Company Name</ControlLabel>
                            <FormControl
                                value={company}
                                onChange={e => setCompany(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup controlId="phone" className="account-info-field">
                            <ControlLabel>Phone Number</ControlLabel>
                            <FormControl
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup controlId="email" className="account-info-field account-info-field--full">
                            <ControlLabel>Account Email</ControlLabel>
                            <FormControl
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </FormGroup>
                    </div>
                    <div className="account-info-actions">
                        <LoaderButton
                            block
                            type="submit"
                            className="btn-brand-dark"
                            bsSize="large"
                            isLoading={isLoading}
                        >
                            Save
                        </LoaderButton>
                    </div>
                </form>
            </div>
        </div>
    )
}
